import userReducer from './userReducer';

export default userReducer;